import type { Log as ApiLog, LogDetail as ApiLogDetail } from '../services/api/generated/model';

export enum LogDetailChangeType {
  CREATE = 1,
  UPDATE = 2,
  DELETE = 3,
}

// LogDetail consolidates the response shape with the snapshot fields
// (entityName, parentEntityName) emitted on history endpoints.
export type LogDetail = Omit<ApiLogDetail, 'entityName' | 'parentEntityName' | 'type' | 'oldValue' | 'newValue'> & {
  oldValue?: string;
  newValue?: string;
  type: LogDetailChangeType;
  entityName: string;
  parentEntityName: string;
};

// Stores demand a `name`; logs have no backend name so the phantom keeps GenericStore happy.
export type Log = Omit<ApiLog, 'comment' | 'userId' | 'details'> & {
  name: string;
  comment?: string;
  userId?: number;
  details?: LogDetail[];
};
